<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarForGnbPmTaskManagement">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Pm.createPmTask")' :click="buttonClick" operate='add'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Pm.enableTask")' :click="buttonClick" operate='enable'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Pm.disableTask")' :click="buttonClick" operate='disable'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Pm.deleteTask")' :click="buttonClick" operate='delete'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("Pm.uploadTask")' :click="buttonClick" operate='upload'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
    export default {
      name: "PmTaskManagementToolBarForGnb",
      props: [
        'enableStatus'
      ],
      methods: {
        buttonClick(args) {
          this.$parent.$parent.methodList(args.item.operate);
        }
      },
      watch: {
        enableStatus(enableStatus){
          switch (enableStatus) {
            case '0': // 任务关闭
              this.$refs.toolBarForGnbPmTaskManagement.enableItems([0, 1, 3, 4], true);
              this.$refs.toolBarForGnbPmTaskManagement.enableItems([2], false);
              break;
            case '1': // 任务开启
              this.$refs.toolBarForGnbPmTaskManagement.enableItems([0, 2, 3, 4], true);
              this.$refs.toolBarForGnbPmTaskManagement.enableItems([1], false);
              break;
            default:
              this.$refs.toolBarForGnbPmTaskManagement.enableItems([0], true);
              this.$refs.toolBarForGnbPmTaskManagement.enableItems([1, 2, 3, 4], false);
              break;
          }
        }
      },
      mounted() {
        this.$refs.toolBarForGnbPmTaskManagement.enableItems([0], true);
        this.$refs.toolBarForGnbPmTaskManagement.enableItems([1, 2, 3, 4], false);
      }
    }
</script>

<style scoped>

</style>
